export const LabNavKeys = {
    Dashboard: 'dashboard',
    Template: 'template',
    VirualMachine: 'virtual machines',
    Users: 'users',
    Schedule: 'schedule',
    Settings: 'settings',
};
export default LabNavKeys;
